import classNames from "classnames";
import { FC } from "react";

import Modal from "components/Modal";

import NoticeContent from "./NoticeContent";

import styles from "./styles.module.scss";

type PropTypes = {
  title?: string;
  buttonText?: string;
  buttonText2?: string;
  onClick2?: () => void;
  className?: string;
  onClick?: () => void;
  isVisible: boolean;
  description?: string;
};

const WidgetModalNotice: FC<PropTypes> = ({
  title,
  className,
  onClick,
  isVisible,
  buttonText,
  description,
  buttonText2,
  onClick2,
}) => {
  return (
    <Modal isClose isCloseBg isVisible={isVisible} className={classNames(styles.modalNotice, className)}>
      <NoticeContent
        buttonText={buttonText}
        onClick={onClick}
        title={title}
        description={description}
        buttonText2={buttonText2}
        onClick2={onClick2}
      />
    </Modal>
  );
};

export default WidgetModalNotice;
